// extracted by mini-css-extract-plugin
module.exports = {"c-select":"select_c-select__KURcT"};